module.exports = __webpack_public_path__ + "static/media/lock-2-final.c2d0a298.svg";